var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"article-item-component",attrs:{"to":{ name: 'article_view', params: { id: _vm.item.id } },"target":_vm.linkTarget}},[_c(_vm.view,{tag:"component",attrs:{"item":_vm.item,"size":_vm.size,"theme":_vm.theme}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }